import styled from 'styled-components';

export const Shell = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100vw;
  height: 100vh;
  background-color: rgba(86, 92, 97, 0.7);
  backdrop-filter: blur(5px);
  z-index: 1;
  position: fixed;
  top: 0;
  left: 0;

  @media only screen and (max-width: 1100px) {
    padding-top: 20px;
  }
`;

export const ContentWrap = styled.div`
  display: flex;
  flex-direction: column;
  padding: 22px 35px 35px 35px;
  width: 90.135vw;
  max-height: 43.75vw;
  background-color: #f2f5f7;
  border-radius: 20px;
`;

export const HeadingRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
`;

export const ModalTitle = styled.div`
  font-size: 24px;
  color: #415364;
  font-family: 'Poppins';
  font-weight: 600;
`;

export const Button = styled.button`
  border: none;
  background-color: #0071ce;
  color: white;
  font-size: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40px;
  width: 160px;
  font-family: 'Poppins';
  border-radius: 0.5rem;
  font-weight: 600;

  &:hover {
    cursor: pointer;
    background-color: #005daa;
    .icon-close {
      background-color: #005daa;
    }
  }

  .icon-close {
    display: block;
    width: 30px;
    padding: 6px;
    background-color: #0071ce;
    border-radius: 100%;
    box-sizing: border-box;
    margin-right: 4px;

    path {
      fill: white;
    }
  }
`;
